import { MouseEvent } from 'react'
import type { DocumentRecord } from '@/types/catalog'

export const DOC_TYPES = {
  graph: 'graph',
  pnid: 'pnid',
  pfd: 'pfd',
  sld: 'sld', // Single-line diagram — no parser, annotated by hand
  document: 'document',
  interview: 'interview',
  transcript: 'transcript', // FS-557 call-transcript artifact, shown as "User Artifacts"
  table: 'datasheet', // DEPRECATED: No longer filterable but kept for displaying legacy files
  timeseries: 'timeseries',
  plc_program: 'plc_program', // PLC program exports (VISN-305), flag-gated
  video: 'video', // Rendered "Explain as video" brief; generated, never uploaded
}

export const DOC_TYPE_DISPLAY_MAP = {
  all: 'All',
  graph: 'Graph',
  pnid: 'P&ID',
  pfd: 'PFD',
  sld: 'SLD',
  document: 'Document',
  interview: 'Interview',
  transcript: 'User Artifacts',
  datasheet: 'Table',
  plc_program: 'PLC Program',
  video: 'Video Brief',
}

export type RowAction = {
  name: string
  file_type?: string[]
  icon?: React.ReactNode
  action: (
    e: MouseEvent<HTMLButtonElement | HTMLDivElement>,
    id: string
  ) => void
  condition?: (doc: DocumentRecord) => boolean
  isRename?: boolean
}
